<template>
  <div class="c-footer">
    <div class="c-footer__top">
      <a class="is-logo" :href="`/collections/luxury/2023/${pathPrefix}`">
        <h1><img :src="`${$store.getters.assetsPath}img/footer/logo@2x.png`" alt="999.9" width="100" height="56" /></h1>
        <p>NEW COLLECTION 2023-2024</p>
        <div><img class="logo-luxury" :src="`${$store.getters.assetsPath}img/common/logo-luxury-w@2x.png`" alt="LUXURY" width="121" height="21" /></div>
      </a>
    </div>
    <div class="c-footer__bottom">
      <ul class="is-nav">
        <li><a :href="`/collections/luxury/2023/${pathPrefix}`">Home</a></li>
        <li><a :href="this.$store.getters.shoplistURL[this.lang]" target="_blank">Shop list</a></li>
        <li><a :href="this.$store.getters.officialURL[this.lang]" target="_blank">999.9 Official Site</a></li>
      </ul>
      <ul class="is-sns">
        <li>
          <a href="https://www.facebook.com/FourNines.co.jp" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-fb@2x.png`" alt="facebook" width="32" height="32" />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/999.9_fournines/" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-insta@2x.png`" alt="instagram" width="32" height="32" />
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/channel/UCMsksMVNqQdUeCGkAAjpTMA" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-youtube@2x.png`" alt="youtube" width="32" height="32" />
          </a>
        </li>
        <li>
          <a href="https://page.line.me/545vwtra?openQrModal=true" target="_blank">
            <img :src="`${$store.getters.assetsPath}img/footer/btn-line@2x.png`" alt="line" width="32" height="32" />
          </a>
        </li>
      </ul>
      <small>&copy; Four Nines Co.,Ltd. All Rights Reserved.</small>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: '',
      pathPrefix: '',
    }
  },
  computed: {
  },
  mounted() {
    this.lang = this.$store.getters.lang;
    this.pathPrefix = this.$store.getters.pathPrefix;
  },
  methods: {
  }
}
</script>